/* import __COLOCATED_TEMPLATE__ from './sort-select.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { action } from '@ember/object';
import { taskFor } from 'ember-concurrency-ts';
import { restartableTask } from 'ember-concurrency-decorators';
import type AiContentLibraryApi from 'embercom/lib/ai-content-library/list-api';
import { type TaskGenerator } from 'ember-concurrency';
import { SortableFields, type SortDirection } from 'embercom/lib/suggestions/constants';

interface Args {
  listApi: AiContentLibraryApi;
}

export default class SortSelect extends Component<Args> {
  @service declare intl: IntlService;

  get sortOptions() {
    return [
      {
        text: this.intl.t('ai-agent.suggestions.sorting.newest'),
        value: `${SortableFields.SuggestedAt}-desc`,
      },
      {
        text: this.intl.t('ai-agent.suggestions.sorting.oldest'),
        value: `${SortableFields.SuggestedAt}-asc`,
      },
    ];
  }

  get selectedSortOption() {
    return `${SortableFields.SuggestedAt}-desc`;
  }

  @action
  onSelectItem(value: string) {
    let [sortBy, sortDirection] = value.split('-') as [SortableFields, SortDirection];
    taskFor(this.sortUpdate).perform(sortBy, sortDirection);
  }

  @restartableTask
  *sortUpdate(sortBy: SortableFields, sortDirection: SortDirection): TaskGenerator<void> {
    yield this.args.listApi.sortUpdate(sortBy, sortDirection);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::SortSelect': typeof SortSelect;
  }
}
